import { gql } from 'graphql-request'

/* TODO: Create a GraphQL Fragment for Reservation Lists. */
export default {
  getReservationsList: gql`
    query getReservationsList(
      $filter: ReservationsFilter = { limit: 50 }
      $searchString: String
      $sortBy: ReservationSort
    ) {
      reservations(filter: $filter, searchString: $searchString, sortBy: $sortBy) {
        id
        cancelledAt
        moveInDate
        moveOutDate
        monthlyRent
        source
        flightxInProgress
        lexit
        status
        home {
          id
          unitNumber
          searchDocument
        }
        homeQualityStatus
        member {
          fullName
          phone
        }
      }
    }
  `,
  getReservation: gql`
    query getReservation($reservation: Int!) {
      reservation(id: $reservation) {
        id
        moveInDate
        moveOutDate
        monthlyRent
        rentalApplicationId
        moveInMethod
        checkInAt
        slug
        status
        flightxInProgress
        lexit
        professionalHousing
        standby
        includeDamageWaiverFee
        home {
          id
          unitNumber
          bedrooms
          baths
          property {
            id
            name
            address1
            address2
            parking
            pool
            state
            zip
            landingLite
          }
        }
        member {
          fullName
          email
          phone
          dateOfBirth
          id
          organizationBlocksCommunication
        }
      }
    }
  `,
  getReservationCheckinDetails: gql`
    query getReservation($id: Int!) {
      reservation(id: $id) {
        jobs(filter: { templateType: "Check In", cancelled: false }) {
          host {
            fullName
          }
          scheduleDate
          startsAt
          id
          market {
            timezone
          }
        }
      }
    }
  `,
  searchReservation: gql`
    query getReservationsList($filter: ReservationsFilter = { limit: 20 }, $searchString: String) {
      reservations(filter: $filter, searchString: $searchString) {
        home {
          id
          searchDocument
        }
        id
        status
      }
    }
  `,
}
